import * as fromProcesses from "../actions/process.actions";
import { GematikProcessTotals } from "../../models/gematik-process-totals.model";

export const FEATURE_KEY = "processTotals";

export interface ProcessTotalsState {
  totals: GematikProcessTotals;
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export const initialState: ProcessTotalsState = {
  totals: {
    open: {
      my: 0,
      group: 0,
    },
    due: {
      my: 0,
      group: 0,
    },
    completed: {
      my: 0,
      group: 0,
    },
  },
  loading: false,
  loaded: false,
  error: false,
};

export function reducer(
  state = initialState,
  action: fromProcesses.ProcessActions,
): ProcessTotalsState {
  switch (action.type) {
    case fromProcesses.LOAD_PROCESS_TOTALS: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case fromProcesses.LOAD_PROCESS_TOTALS_SUCCESS: {
      const totals = action.payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        totals,
      };
    }
    case fromProcesses.LOAD_PROCESS_TOTALS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case fromProcesses.ADJUST_PROCESS_TOTALS: {
      const { openMy, openGroup, completedMy, completedGroup } = action.payload;
      return {
        ...state,
        totals: {
          ...state.totals,
          open: {
            my: state.totals.open.my + openMy,
            group: state.totals.open.group + openGroup,
          },
          completed: {
            my: state.totals.completed.my + completedMy,
            group: state.totals.completed.group + completedGroup,
          },
        },
      };
    }
  }
  return state;
}

export const getProcessTotals = (state: ProcessTotalsState) => state.totals;
export const getProcessTotalsLoading = (state: ProcessTotalsState) => state.loading;
export const getProcessTotalsLoaded = (state: ProcessTotalsState) => state.loaded;
